import React from 'react';

import styled from '@emotion/styled';

import StarFillIcon from '../../Icons/StarFillIcon';

const RatingMetricTooltip = ({ active, payload, label, tooltipLabel }: any) => {
  if (active && payload && payload.length) {
    const dataPoint = payload[0].payload;

    return (
      <TooltipContainer>
        <TooltipLabel>{tooltipLabel || 'Value'}</TooltipLabel>
        <TooltipValue>
          <StarFillIcon />
          {dataPoint.averageRating} ({payload[0].value})
        </TooltipValue>
      </TooltipContainer>
    );
  }
  return null;
};

export default RatingMetricTooltip;

const TooltipContainer = styled.div`
  background: white;
  border-radius: 6px;
  padding: 4px 12px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  max-width: 116px;
`;

const TooltipLabel = styled.div`
  font-size: 10px;
  color: #6b7280;
  font-weight: 400;
  text-align: center;
`;

const TooltipValue = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
`;
